// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"70":"af034e52","79":"8068e867","181":"e6cdee0c","250":"fc0e16c5","323":"344ed174","789":"51cdda55"}[chunkId] + ".chunk.js";
};